/* eslint-disable */
export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.rtc = {};
    Blockly.Blocks.rtc.style = 'rtc_blocks';
    Blockly.Blocks.rtc_set_time = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.rtc.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.RTC)
                .appendField(new Blockly.FieldImage(img_path + "arduino/sensor_rtc.svg", 45, 45));
            // Hour input
            this.appendValueInput("HOUR", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.RTC_HOUR + " = ");
            // Minute input
            this.appendValueInput("MINUTE", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.RTC_MINUTE +" = ");
            // Second input
            this.appendValueInput("SECOND", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.RTC_SECOND + " = ");
            // Day input
            this.appendValueInput("DAY", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.RTC_DAY + " = ");
            // Month input
            this.appendValueInput("MONTH", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.RTC_MONTH + " = ");
            // Year input
            this.appendValueInput("YEAR", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.RTC_YEAR + " = ");
           
            
            
                
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.rtc_set = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.rtc.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.RTC)
                .appendField(new Blockly.FieldImage(img_path + "arduino/sensor_rtc.svg", 45, 45));
            this.appendDummyInput("").appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.RTC_SECOND, "second"],
                [Blockly.Msg.RTC_MINUTE, "minute"],
                [Blockly.Msg.RTC_HOUR, "hour"],
                [Blockly.Msg.RTC_DAY, "day"],
                [Blockly.Msg.RTC_MONTH, "month"],
                [Blockly.Msg.RTC_YEAR, "year"]
            ]), "FIELD").appendField("=");
            this.appendValueInput("VALUE", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.rtc_get = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.rtc.style);
            this.appendDummyInput("").appendField(Blockly.Msg.RTC)
                .appendField(new Blockly.FieldImage(img_path + "arduino/sensor_rtc.svg", 45, 45))
                .appendField(new Blockly.FieldDropdown([
                    [Blockly.Msg.RTC_SECOND, "second"],
                    [Blockly.Msg.RTC_MINUTE, "minute"],
                    [Blockly.Msg.RTC_HOUR, "hour"],
                    [Blockly.Msg.RTC_DAY, "day"],
                    [Blockly.Msg.RTC_MONTH, "month"],
                    [Blockly.Msg.RTC_YEAR, "year"]
            ]), "FIELD");
            this.setOutput(!0, "Number")
        }
    };
    Blockly.Blocks.rtc_get_time_text = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.rtc.style);
            this.appendDummyInput("").appendField(Blockly.Msg.RTC)
                .appendField(new Blockly.FieldImage(img_path + "arduino/sensor_rtc.svg", 45, 45));
            this.appendDummyInput("").appendField(Blockly.Msg.RTC_TIME_TEXT);
            this.setInputsInline(!0);
            this.setOutput(!0, "String")
        }
    };
    Blockly.Blocks.rtc_get_date_text = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.rtc.style);
            this.appendDummyInput("").appendField(Blockly.Msg.RTC)
                .appendField(new Blockly.FieldImage(img_path + "arduino/sensor_rtc.svg", 45, 45));
            this.appendDummyInput("").appendField(Blockly.Msg.RTC_DATE_TEXT);
            this.setInputsInline(!0);
            this.setOutput(!0, "String")
        }
    };
   
}
